import { px2rem } from "../../../../utils/css";
export const TomatoTwoWidth = 171;
export const TomatoTwoHalfWidth = 141;
export const TomatoOneWidth = 120;
export const TomatoThreeWidth = 111;
export const getTomatoWidth = (col, posterRadio, isRollable) => {
    let cardWidth;
    switch (col) {
        case 1:
            cardWidth = TomatoOneWidth;
            break;
        case 2:
            if (isRollable) {
                cardWidth = TomatoTwoHalfWidth;
            }
            else {
                cardWidth = TomatoTwoWidth;
            }
            break;
        case 3:
            cardWidth = TomatoThreeWidth;
            break;
        default:
            cardWidth = TomatoTwoWidth;
    }
    return {
        imgWidth: px2rem(cardWidth),
        imgHeight: px2rem(cardWidth * posterRadio),
    };
};
export const getInitProduct = (product) => {
    const { img = "", name = "", price = "", originPrice = "", url = "" } = product;
    const { ltImg = "", rtImg = "", sold = "", star = 0, titleImg = "", twentyTour = "", countdownToEnd = "0", } = product === null || product === void 0 ? void 0 : product.extra;
    return {
        img,
        name,
        price,
        originPrice,
        url,
        ltImg,
        rtImg,
        sold,
        star,
        titleImg,
        twentyTour,
        countdownToEnd,
    };
};
